// removed by extract-text-webpack-plugin
module.exports = {"appBtn":"Button__appBtn__2SrvF","appBtnIcon":"Button__appBtnIcon__2sirp","appBtnPrimary":"Button__appBtnPrimary__13NhX","appBtnSecondary":"Button__appBtnSecondary__3IG57","getInTouch":"Button__getInTouch__17ksv","appContactMeBtn":"Button__appContactMeBtn__2sxHb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 253
// module chunks = 0